// src/pages/TherapistToolsPage.js
import React, { useState, useEffect } from "react";
import API from "../services/api";

// Simple capitalizer
function capitalize(str) {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

function TherapistToolsPage() {
  // ------------------------------
  // RENAME-A-CLIENT States
  // ------------------------------
  const [clients, setClients] = useState([]);
  const [selectedClientId, setSelectedClientId] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [status, setStatus] = useState("");

  // ------------------------------
  // PASSWORD CHANGE States
  // ------------------------------
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [pwStatus, setPwStatus] = useState("");

  // Fetch clients on mount
  useEffect(() => {
    fetchClients();
  }, []);

  const fetchClients = async () => {
    try {
      const res = await API.get("/therapist/clients");
      // Sort them by client_name if desired:
      const sorted = res.data.sort((a, b) =>
        a.client_name.localeCompare(b.client_name)
      );
      setClients(sorted);
    } catch (err) {
      console.error("Error fetching clients:", err);
    }
  };

  // --------------------------------------
  // 1) RENAME CLIENT
  // --------------------------------------
  const handleRename = async () => {
    if (!selectedClientId) {
      alert("Please select a client.");
      return;
    }
    if (!firstName.trim() || !lastName.trim()) {
      alert("Please fill both first and last name fields.");
      return;
    }

    // Capitalize and form "Last, First"
    const finalFirst = capitalize(firstName.trim());
    const finalLast = capitalize(lastName.trim());
    const combinedName = `${finalLast}, ${finalFirst}`;

    try {
      await API.put(`/therapist/clients/${selectedClientId}`, {
        clientName: combinedName,
      });
      setStatus("Client name updated successfully.");
      // Clear fields
      setFirstName("");
      setLastName("");
      setSelectedClientId("");
      // Re-fetch the client list
      fetchClients();
    } catch (err) {
      console.error("Error updating client name:", err);
      setStatus("Error updating client name.");
    }
  };

  // --------------------------------------
  // 2) CHANGE PASSWORD
  // --------------------------------------
  const handleChangePassword = async () => {
    setPwStatus("");

    if (!oldPassword || !newPassword) {
      alert("Please fill out all password fields.");
      return;
    }
    if (newPassword !== confirmPassword) {
      alert("New password and Confirm password do not match.");
      return;
    }

    try {
      await API.put("/therapist/password", {
        oldPassword,
        newPassword,
      });
      setPwStatus("Password changed successfully!");
      // Optionally clear fields or force logout
      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");
      // e.g. localStorage.clear(); window.location.reload();
    } catch (err) {
      console.error("Error changing password:", err);
      if (err.response && err.response.data && err.response.data.message) {
        setPwStatus(`Error: ${err.response.data.message}`);
      } else {
        setPwStatus("Error changing password");
      }
    }
  };

  return (
    <div style={{ padding: "1rem" }}>
      <h1>Therapist Tools</h1>

      {/* -----------------------------
          RENAME A CLIENT
       ----------------------------- */}
      <div
        style={{
          border: "1px solid #ccc",
          padding: "1rem",
          marginBottom: "2rem",
          background: "#fff",
        }}
      >
        <h2>Rename a Client</h2>

        <div style={{ marginBottom: "1rem" }}>
          <label>Select a client:</label>
          <br />
          <select
            value={selectedClientId}
            onChange={(e) => setSelectedClientId(e.target.value)}
          >
            <option value="">-- Select Client --</option>
            {clients.map((client) => (
              <option key={client.id} value={client.id}>
                {client.client_name}
              </option>
            ))}
          </select>
        </div>

        <div style={{ marginBottom: "1rem" }}>
          <label>First Name:</label>
          <br />
          <input
            type="text"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
        </div>

        <div style={{ marginBottom: "1rem" }}>
          <label>Last Name:</label>
          <br />
          <input
            type="text"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
        </div>

        <button onClick={handleRename}>Update Client Name</button>

        {status && <p style={{ marginTop: "1rem" }}>{status}</p>}
      </div>

      {/* -----------------------------
          CHANGE PASSWORD
       ----------------------------- */}
      <div
        style={{
          border: "1px solid #ccc",
          padding: "1rem",
          background: "#fff",
        }}
      >
        <h2>Change Password</h2>

        <div style={{ marginBottom: "1rem" }}>
          <label>Old Password:</label>
          <br />
          <input
            type="password"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
          />
        </div>

        <div style={{ marginBottom: "1rem" }}>
          <label>New Password:</label>
          <br />
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
        </div>

        <div style={{ marginBottom: "1rem" }}>
          <label>Confirm New Password:</label>
          <br />
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </div>

        <button onClick={handleChangePassword}>Update Password</button>

        {pwStatus && <p style={{ marginTop: "1rem" }}>{pwStatus}</p>}
      </div>
    </div>
  );
}

export default TherapistToolsPage;
